import Axios from 'axios'
import { setupCache, buildWebStorage } from 'axios-cache-interceptor'

const optionsAxios = {
  baseURL: process.env.VUE_APP_API_LEGACY_URL,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
}

export default (
  options = {
    cache: false,
    authorization: false,
    wedId: undefined,
  }
) => {
  if (options.authorization) {
    optionsAxios.headers['Authorization'] = options.authorization
  }

  if (!options.cache) return Axios.create(optionsAxios)
  return setupCache(Axios.create(optionsAxios), {
    storage: buildWebStorage(sessionStorage, `wed${options.wedId}:`),
    cacheTakeover: false,
  })
}
